<app-page-header
  title="Home"
  titleLink="/operator-list"
  active_item="Lista de Operadores"
>
</app-page-header>

<form [formGroup]="filters">
  <div class="row">
    <h5>Operadores</h5>

    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed,
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
            >
              <i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i>
            </a>
          </div>
        </div>

        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtCnpj" class="form-label">CNPJ</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    type="text"
                    id="txtCnpj"
                    [formControl]="filters.controls.cnpj"
                    mask="CPF_CNPJ"
                    placeholder="Digite o CNPJ"
                  />
                  <i
                    class="fe fe-clipboard input-icon btn-color"
                    (click)="paste()"
                  ></i>
                </div>
              </div>
            </div>

            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar()"
              >
                <i class="fe fe-search me-2"></i>
                {{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">Operadores Cadastrados</div>
          <div class="card-options">
            <button type="button" class="btn btn-pill btn-default-light">
              <i class="fe fe-download me-2"></i>Exportar Excel
            </button>
            <button
              type="button"
              class="btn btn-pill btn-default-light"
              (click)="downloadPdf()"
            >
              <i class="fe fe-download me-2"></i>Exportar PDF
            </button>
          </div>
        </div>

        <div class="card-body button-table">
          <app-table-operator-list
            (transactionsLoaded)="onTransactionsLoaded($event)"
          ></app-table-operator-list>
        </div>
      </div>
    </div>
  </div>
</form>
